import React from 'react'
import { TfiLinkedin, TfiGithub, TfiTwitterAlt } from 'react-icons/tfi'

const SocialMedia = () => (
  <div className='app__social'>
    <a
      href='https://www.linkedin.com/in/manuel-perdomo-698311b3/'
      target='_blank'
      rel='noopener noreferrer'
    >
      <div>
        <TfiLinkedin />
      </div>
    </a>
    <a
      href='https://github.com/SisifoDev'
      target='_blank'
      rel='noopener noreferrer'
    >
      <div>
        <TfiGithub />
      </div>
    </a>
    <a
      href='https://twitter.com/manuelperd1710'
      target='_blank'
      rel='noopener noreferrer'
    >
      <div>
        <TfiTwitterAlt />
      </div>
    </a>
  </div>
)

export default SocialMedia
